import WorkingEmoji from "../../media/working.png";
import React from "react";

function AboutMe() {
  return (
    <>
      <section className="about" id="about">
        <div className="container">
          <div className="about-content">
            <div className="img-side">
              <img
                src={WorkingEmoji}
                alt="mee"
                className="img-side__main-img"
              />
            </div>
            <div className="text-side">
              <h4>About me</h4>
              <h3>
                A dedicated Flutter Developer <br /> based in India
              </h3>
              <p>
                As a senior Flutter Developer, I possess an impressive arsenal
                of skills in Dart, Kotlin, Swift & Firebase. I Excel in
                designing and maintaining responsive mobile apps that offer a
                smooth user experience. My expertise lies in crafting dynamic,
                engaging interfaces through writing clean and optimized code and
                utilizing cutting-edge development tools and techniques. I am
                also a team player who thrives in collaborating with
                cross-functional teams to produce outstanding mobile
                applications.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutMe;
